import React, { useState, useEffect } from 'react';
import { FileText, Download, CheckCircle } from 'lucide-react';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

export default function StockCertificateGenerator() {
  const [activeTab, setActiveTab] = useState('create');
  const [certificates, setCertificates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  const [formData, setFormData] = useState({
    company_name: '',
    share_price: '',
    quantity: '',
    transaction_date: new Date().toISOString().split('T')[0],
    holder_name: '',
    holder_email: ''
  });

  const [verifyData, setVerifyData] = useState({
    unique_id: '',
    digital_signature: ''
  });

  useEffect(() => {
    if (activeTab === 'list') {
      fetchCertificates();
    }
  }, [activeTab]);

  const fetchCertificates = async () => {
    try {
      const response = await fetch(`${API_URL}/certificates`);
      const data = await response.json();
      setCertificates(data.certificates || []);
    } catch (error) {
      showMessage('error', 'Failed to fetch certificates');
    }
  };

  const showMessage = (type, text) => {
    setMessage({ type, text });
    setTimeout(() => setMessage({ type: '', text: '' }), 5000);
  };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async () => {
    if (!formData.company_name || !formData.share_price || !formData.quantity || !formData.holder_name) {
      showMessage('error', 'Please fill all required fields');
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${API_URL}/certificates`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (response.ok) {
        showMessage('success', `Certificate created! ID: ${data.certificate.unique_id}`);
        setFormData({
          company_name: '',
          share_price: '',
          quantity: '',
          transaction_date: new Date().toISOString().split('T')[0],
          holder_name: '',
          holder_email: ''
        });
        
        downloadPDF(data.certificate.unique_id);
      } else {
        showMessage('error', data.error || 'Failed to create certificate');
      }
    } catch (error) {
      showMessage('error', 'Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const downloadPDF = async (uniqueId) => {
    try {
      const response = await fetch(`${API_URL}/certificates/${uniqueId}/pdf`);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `certificate_${uniqueId}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      showMessage('error', 'Failed to download PDF');
    }
  };

  const handleVerify = async () => {
    if (!verifyData.unique_id || !verifyData.digital_signature) {
      showMessage('error', 'Please fill all fields');
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${API_URL}/certificates/verify`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(verifyData)
      });

      const data = await response.json();

      if (data.valid) {
        showMessage('success', 'Certificate is valid and authentic!');
      } else {
        showMessage('error', data.message || 'Certificate verification failed');
      }
    } catch (error) {
      showMessage('error', 'Verification failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const totalAmount = formData.share_price && formData.quantity 
    ? (parseFloat(formData.share_price) * parseInt(formData.quantity)).toFixed(2)
    : '0.00';

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 p-4">
      <div className="max-w-6xl mx-auto">
        <div className="bg-white rounded-lg shadow-lg p-6 mb-6">
          <div className="flex items-center gap-3 mb-2">
            <FileText className="w-8 h-8 text-indigo-600" />
            <h1 className="text-3xl font-bold text-gray-800">Stock Certificate Generator</h1>
          </div>
          <p className="text-gray-600">Generate official digitally signed stock transaction certificates</p>
        </div>

        {message.text && (
          <div className={`mb-6 p-4 rounded-lg ${
            message.type === 'success' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
          }`}>
            {message.text}
          </div>
        )}

        <div className="bg-white rounded-lg shadow-lg mb-6">
          <div className="flex border-b">
         {/*  
	  <button
              onClick={() => setActiveTab('create')}
              className={`flex-1 px-6 py-3 font-semibold ${
                activeTab === 'create'
                  ? 'text-indigo-600 border-b-2 border-indigo-600'
                  : 'text-gray-600 hover:text-gray-800'
              }`}
            >
              Create Certificate
            </button>
            <button
              onClick={() => setActiveTab('list')}
              className={`flex-1 px-6 py-3 font-semibold ${
                activeTab === 'list'
                  ? 'text-indigo-600 border-b-2 border-indigo-600'
                  : 'text-gray-600 hover:text-gray-800'
              }`}
            >
              View All
            </button>
        
          */}
      
	<button
              onClick={() => setActiveTab('verify')}
              className={`flex-1 px-6 py-3 font-semibold ${
                activeTab === 'verify'
                  ? 'text-indigo-600 border-b-2 border-indigo-600'
                  : 'text-gray-600 hover:text-gray-800'
              }`}
            >
              Verify Certificate
            </button>
          </div>

          <div className="p-6">
   {/*  
          {activeTab === 'create' && (
              <div className="space-y-6">
                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Company Name *
                    </label>
                    <input
                      type="text"
                      name="company_name"
                      value={formData.company_name}
                      onChange={handleInputChange}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                      placeholder="e.g., Apple Inc."
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Holder Name *
                    </label>
                    <input
                      type="text"
                      name="holder_name"
                      value={formData.holder_name}
                      onChange={handleInputChange}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                      placeholder="e.g., Ram AM"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Share Price ($) *
                    </label>
                    <input
                      type="number"
                      name="share_price"
                      value={formData.share_price}
                      onChange={handleInputChange}
                      step="0.01"
                      min="0"
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                      placeholder="0.00"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Quantity *
                    </label>
                    <input
                      type="number"
                      name="quantity"
                      value={formData.quantity}
                      onChange={handleInputChange}
                      min="1"
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                      placeholder="0"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Transaction Date *
                    </label>
                    <input
                      type="date"
                      name="transaction_date"
                      value={formData.transaction_date}
                      onChange={handleInputChange}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Holder Email
                    </label>
                    <input
                      type="email"
                      name="holder_email"
                      value={formData.holder_email}
                      onChange={handleInputChange}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                      placeholder="support@vrksatechnology.in"
                    />
                  </div>
                </div>

                <div className="bg-indigo-50 p-4 rounded-lg">
                  <div className="flex justify-between items-center">
                    <span className="text-lg font-semibold text-gray-700">Total Amount:</span>
                    <span className="text-2xl font-bold text-indigo-600">${totalAmount}</span>
                  </div>
                </div>

                <button
                  onClick={handleSubmit}
                  disabled={loading}
                  className="w-full bg-indigo-600 text-white py-3 rounded-lg font-semibold hover:bg-indigo-700 disabled:bg-gray-400 transition-colors flex items-center justify-center gap-2"
                >
                  {loading ? (
                    'Processing...'
                  ) : (
                    <>
                      <FileText className="w-5 h-5" />
                      Generate Certificate & Download PDF
                    </>
                  )}
                </button>
              </div>
            )}

            {activeTab === 'list' && (
              <div className="space-y-4">
                {certificates.length === 0 ? (
                  <div className="text-center py-12 text-gray-500">
                    No certificates found. Create your first certificate!
                  </div>
                ) : (
                  certificates.map((cert) => (
                    <div key={cert.id} className="border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow">
                      <div className="flex justify-between items-start mb-3">
                        <div>
                          <h3 className="font-bold text-lg text-gray-800">{cert.company_name}</h3>
                          <p className="text-sm text-gray-600">ID: {cert.unique_id}</p>
                        </div>
                        <button
                          onClick={() => downloadPDF(cert.unique_id)}
                          className="flex items-center gap-2 bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700 transition-colors"
                        >
                          <Download className="w-4 h-4" />
                          Download PDF
                        </button>
                      </div>
                      <div className="grid md:grid-cols-3 gap-4 text-sm">
                        <div>
                          <span className="font-semibold">Holder:</span> {cert.holder_name}
                        </div>
                        <div>
                          <span className="font-semibold">Quantity:</span> {cert.quantity} shares
                        </div>
                        <div>
                          <span className="font-semibold">Amount:</span> ${parseFloat(cert.total_amount).toFixed(2)}
                        </div>
                        <div>
                          <span className="font-semibold">Price:</span> ${parseFloat(cert.share_price).toFixed(2)}
                        </div>
                        <div>
                          <span className="font-semibold">Date:</span> {new Date(cert.transaction_date).toLocaleDateString()}
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>
            )}
          */}
            {activeTab === 'verify' && (
              <div className="space-y-6">
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Certificate ID *
                  </label>
                  <input
                    type="text"
                    value={verifyData.unique_id}
                    onChange={(e) => setVerifyData({ ...verifyData, unique_id: e.target.value })}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                    placeholder="CERT-XXXXXXXXX"
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Digital Signature *
                  </label>
                  <textarea
                    value={verifyData.digital_signature}
                    onChange={(e) => setVerifyData({ ...verifyData, digital_signature: e.target.value })}
                    rows={4}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent font-mono text-sm"
                    placeholder="Enter the digital signature from the certificate"
                  />
                </div>

                <button
                  onClick={handleVerify}
                  disabled={loading}
                  className="w-full bg-green-600 text-white py-3 rounded-lg font-semibold hover:bg-green-700 disabled:bg-gray-400 transition-colors flex items-center justify-center gap-2"
                >
                  {loading ? (
                    'Verifying...'
                  ) : (
                    <>
                      <CheckCircle className="w-5 h-5" />
                      Verify Certificate
                    </>
                  )}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
